export const COUNTRY_CODES = [
   { code: '+1', country: 'United States' },
   { code: '+1', country: 'Canada' },
   { code: '+44', country: 'United Kingdom' },
   { code: '+61', country: 'Australia' },
   { code: '+81', country: 'Japan' },
   { code: '+86', country: 'China' },
   { code: '+91', country: 'India' },
   { code: '+33', country: 'France' },
   { code: '+49', country: 'Germany' },
   { code: '+39', country: 'Italy' },
   { code: '+34', country: 'Spain' },
   { code: '+31', country: 'Netherlands' },
   { code: '+46', country: 'Sweden' },
   { code: '+47', country: 'Norway' },
   { code: '+45', country: 'Denmark' },
   { code: '+358', country: 'Finland' },
   { code: '+41', country: 'Switzerland' },
   { code: '+43', country: 'Austria' },
   { code: '+32', country: 'Belgium' },
   { code: '+353', country: 'Ireland' },
   { code: '+351', country: 'Portugal' },
   { code: '+48', country: 'Poland' },
   { code: '+420', country: 'Czech Republic' },
   { code: '+36', country: 'Hungary' },
   { code: '+40', country: 'Romania' },
   { code: '+30', country: 'Greece' },
   { code: '+90', country: 'Turkey' },
   { code: '+966', country: 'Saudi Arabia' },
   { code: '+971', country: 'United Arab Emirates' },
   { code: '+65', country: 'Singapore' },
   { code: '+60', country: 'Malaysia' },
   { code: '+62', country: 'Indonesia' },
   { code: '+63', country: 'Philippines' },
   { code: '+66', country: 'Thailand' },
   { code: '+84', country: 'Vietnam' },
   { code: '+82', country: 'South Korea' },
   { code: '+852', country: 'Hong Kong' },
   { code: '+886', country: 'Taiwan' },
   { code: '+55', country: 'Brazil' },
   { code: '+54', country: 'Argentina' },
   { code: '+56', country: 'Chile' },
   { code: '+57', country: 'Colombia' },
   { code: '+52', country: 'Mexico' },
   { code: '+27', country: 'South Africa' },
   { code: '+20', country: 'Egypt' },
   { code: '+234', country: 'Nigeria' },
]

export const getCountryByCode = (code) => {
   return COUNTRY_CODES.find((item) => item.code === code)
}

export const getUniqueCountryCodes = () => {
   const uniqueCodes = new Map()
   COUNTRY_CODES.forEach((item) => {
      if (!uniqueCodes.has(item.code)) {
         uniqueCodes.set(item.code, item)
      }
   })
   return Array.from(uniqueCodes.values()).sort((a, b) =>
      a.code.localeCompare(b.code),
   )
}
